import { ShieldCheck, UserCheck, Users } from "lucide-react";
import { EyebrowPill } from "@/components/shared/EyebrowPill";
import { SectionHeading } from "@/components/shared/SectionHeading";

const trustPoints = [
  {
    icon: ShieldCheck,
    stat: "2025 Standards",
    label: "Purpose-Built for the New Framework",
    description:
      "Every register, document, and workflow in ComplyHub is built around the Outcome Standards (F2025L00354) and Compliance Requirements (F2025L00355). Not retrofitted from an older system — designed from the ground up for the 2025 framework.",
  },
  {
    icon: UserCheck,
    stat: "30+ Years",
    label: "Deep VET Sector Experience",
    description:
      "Founded by a compliance specialist who has audited, advised, and built compliance systems for Australian RTOs across every sector and state. ComplyHub solves the problems she spent three decades helping RTOs fix manually.",
  },
  {
    icon: Users,
    stat: "Every Role Covered",
    label: "Built for Your Whole Team",
    description:
      "Compliance Managers, CEOs, Training Managers, and Governing Persons each get the view and tools relevant to their role. One platform, every stakeholder, no information gaps.",
  },
];

const Trust = () => {
  return (
    <section className="py-20 md:py-28 bg-ch-cyanSoft text-ch-acai">
      <div className="container">
        <div className="text-center mb-14 animate-fade-up">
          <EyebrowPill>Why ComplyHub</EyebrowPill>
          <SectionHeading className="mb-5">
            Built by People Who've Lived RTO Compliance
          </SectionHeading>
          <p className="text-lg text-ch-acai/75 max-w-3xl mx-auto">
            ComplyHub was founded by Angela Connell-Richards — compliance consultant, former RTO practitioner, and someone who has spent 30 years helping Australian RTOs prepare for ASQA audits. Every feature exists because she's seen what happens when it doesn't.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto items-stretch">
          {trustPoints.map((point, index) => (
            <div
              key={point.label}
              className={`h-full text-left p-8 rounded-2xl bg-white shadow-ch-card border border-ch-acai/10 transition-all duration-300 hover:shadow-ch-float hover:-translate-y-1 animate-fade-up animate-delay-${(index + 1) * 100}`}
            >
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
                style={{ background: "linear-gradient(135deg, #7130A0, #ED1878)" }}
              >
                <point.icon className="w-8 h-8 text-white" aria-hidden="true" />
              </div>
              <div
                className="font-heading text-ch-purple text-lg mb-2 leading-tight"
              >
                {point.stat}
              </div>
              <div
                className="font-heading text-ch-purple text-lg mb-3"
              >
                {point.label}
              </div>
              <p className="text-ch-acai/75 text-left" style={{ fontSize: "16px" }}>
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trust;
